/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reccurance-icon': {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    data: '<path pid="0" d="M12.338 16.65H7.309C3.563 16.632.55 13.505.55 9.655c0-1.735.671-3.37 1.843-4.584A.789.789 0 113.53 6.167a5.009 5.009 0 00-1.4 3.488c0 3.002 2.335 5.418 5.211 5.418h4.998l-1.28-1.323a.789.789 0 111.135-1.096l2.56 2.648a.786.786 0 010 1.12l-2.56 2.648a.789.789 0 11-1.134-1.096l1.279-1.323zM9.198 2.66h5.025c3.747.015 6.763 3.143 6.763 6.995 0 1.736-.671 3.37-1.843 4.584a.789.789 0 11-1.135-1.095 5.009 5.009 0 001.4-3.49c0-3-2.335-5.417-5.211-5.417H9.199l1.279 1.323a.789.789 0 01-1.134 1.097l-2.56-2.648a.786.786 0 010-1.12L9.344.24a.789.789 0 011.134 1.097L9.198 2.66z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
